import Typography from '@mui/joy/Typography'
import Dropdown from '@mui/joy/Dropdown'
import Menu from '@mui/joy/Menu'
import MenuButton from '@mui/joy/MenuButton'
import MenuItem from '@mui/joy/MenuItem'
import ListDivider from '@mui/joy/ListDivider'
import Add from '@mui/icons-material/Add'

const ActionMenuItemList = ({ actionsMap }) =>
    actionsMap.map((actionMap) => (
        <MenuItem key={actionMap.displayName} onClick={actionMap.func}>
            {actionMap.displayName}
        </MenuItem>
    ))

export const AddLayerDropdown = ({ staticActions, dynamicActions }) => {
    return (
        <>
            <Dropdown>
                <MenuButton color="primary" startDecorator={<Add />}>
                    Add
                </MenuButton>
                <Menu>
                    <Typography
                        color="neutral"
                        level="title-sm"
                        sx={{ ml: 1, mr: 1 }}
                    >
                        Static Objects
                    </Typography>
                    <ActionMenuItemList actionsMap={staticActions} />
                    <ListDivider />
                    <Typography
                        color="neutral"
                        level="title-sm"
                        sx={{ ml: 1, mr: 1 }}
                    >
                        Dynamic Objects
                    </Typography>
                    <ActionMenuItemList actionsMap={dynamicActions} />
                </Menu>
            </Dropdown>
        </>
    )
}
